import { ChallengeCountdown, ChallengeCountdownBody, ChallengeCountdownContent, ChallengeCountdownHat, ChallengeCountdownHeader, ChallengeCountdownText, ChallengeCountdownTitle } from '@/components/custom/challenge';
import { Button, ButtonIcon } from '@/components/ui/button';
import React, { useEffect, useRef } from 'react';
import { FiClock } from 'react-icons/fi';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';

export function DuelsPlayerCountdown({ showQuestionCountDown, setShowQuestionCountDown }) {
  let intervalRef = useRef();

  const { setCurrentStep, setStart, currentStep, currentTaxonomy, setQuestionCountDownTimer, questionCountDownTimer } = useWeeklyChallenge();

  useEffect(() => {
    if (showQuestionCountDown && currentStep === 1) {
      intervalRef.current = setInterval(() => {
        if (questionCountDownTimer > 0) setQuestionCountDownTimer(questionCountDownTimer - 1);
      }, 1000);

      return () => clearInterval(intervalRef.current);
    }
  }, [showQuestionCountDown, questionCountDownTimer]);

  useEffect(() => {
    if (questionCountDownTimer === 0) {
      setShowQuestionCountDown(false);
      if (currentStep < 3) {
        setCurrentStep(currentStep + 1);
      }
      setStart(true);
    }
  }, [questionCountDownTimer]);

  useEffect(() => {
    setQuestionCountDownTimer(5);
  }, [currentTaxonomy]);

  if (!showQuestionCountDown) return null;

  return (
    <ChallengeCountdown>
      <ChallengeCountdownContent>
        <ChallengeCountdownHeader>
          <ChallengeCountdownHat>Tema escolhido:</ChallengeCountdownHat>
          <ChallengeCountdownTitle>{currentTaxonomy?.name}</ChallengeCountdownTitle>
        </ChallengeCountdownHeader>

        <ChallengeCountdownBody>
          <ChallengeCountdownText>Prepare-se!</ChallengeCountdownText>

          <Button
            variant="outline"
            asChild
          >
            <span>
              <ButtonIcon>
                <FiClock className="btn__icon" />
              </ButtonIcon>
              00:0{questionCountDownTimer}
            </span>
          </Button>
        </ChallengeCountdownBody>
      </ChallengeCountdownContent>
    </ChallengeCountdown>
  );
}
